module.exports = require("./os.d.ts");